import React from 'react';
import './style.scss';
import FightResultsInfo from './info';
import FightResultsNftImage from './image';
import FightResultsControls from './controls';
import { API_FightResults } from 'shared';
import FightResultsCongrats from './congrats';

interface Props {
  results: API_FightResults;
  needCongrats: boolean;
}

const FightResults = ({ results, needCongrats }: Props) => (
  <div className='fight-results'>
    <FightResultsCongrats results={results} active={needCongrats} />
    <div className='fr-content'>
      <FightResultsInfo data={results} className='fight-results-info' />
      <FightResultsNftImage
        nft={results.nftData}
        displayCream={results.selfWinner}
        className='fight-results-nft'
      />
      <FightResultsControls
        nft={results.nftData}
        className='fight-results-controls'
      />
    </div>
  </div>
);

export default FightResults;
